"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
var styles_1 = require("@material-ui/core/styles");
var colors_1 = require("@material-ui/core/colors");
var clsx_1 = __importDefault(require("clsx"));
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        alert: {
            backgroundColor: palette.error.main,
            "&:hover": {
                backgroundColor: palette.error.dark,
                color: colors_1.common.white,
            },
        },
        withIcon: {
            justifyContent: "space-between",
        },
    });
});
exports.Button = react_1.forwardRef(function (props, ref) {
    var _a = props.loading, loading = _a === void 0 ? false : _a, _b = props.withIcon, withIcon = _b === void 0 ? false : _b, _c = props.variant, variant = _c === void 0 ? "secondary" : _c, _d = props.size, size = _d === void 0 ? "medium" : _d, className = props.className, others = __rest(props, ["loading", "withIcon", "variant", "size", "className"]);
    var classes = useStyles(others);
    return (react_1.default.createElement(Button_1.default, __assign({ ref: ref, className: clsx_1.default(className, withIcon && classes.withIcon, variant === "alert" && classes.alert), size: size, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { color: "inherit", size: 20 }), endIcon: withIcon && react_1.default.createElement(Icon, { of: "right_arrow" }), variant: variant === "primary" || variant === "alert"
            ? "contained"
            : variant === "secondary"
                ? "outlined"
                : variant }, others)));
});
var Icon = function (_) { return (react_1.default.createElement(SvgIcon_1.default, null,
    react_1.default.createElement("path", { d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" }))); };
